import get from 'lodash/get';
import identityConfig from '../../../../config/identity';

export default function comscore(context, location) {
  const siteConfig = identityConfig[context.site];

  if (siteConfig === undefined) {
    return '';
  }

  const comscoreConfig = get(siteConfig, 'comscore');
  const { c1, publisherId } = comscoreConfig;

  if (location === 'header') {
    return `
      <script>
        var _comscore = _comscore || [];
        _comscore.push({ c1: "${c1}", c2: "${publisherId}" });
        (function() {
        var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;
        s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
        el.parentNode.insertBefore(s, el);
        })();
      </script>
    `;
  }

  return `<noscript><img src="http://b.scorecardresearch.com/p?c1=${c1}&c2=${
    publisherId
  }&cv=2.0&cj=1" /></noscript>`;
}



// WEBPACK FOOTER //
// ./src/views/components/analytics/trackers/comscore.js